import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastPositionDefault, ToastTimeDefault } from './constants';

export const ToastContainerWrapper = (props: any) => {
  return (
    <>
      <ToastContainer
        className="toast-position"
        position={props.position ? props.position : ToastPositionDefault}
        theme="colored"
        autoClose={props.autoClose ? props.autoClose : ToastTimeDefault}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};
